import { SimpleSearchFilter } from 'api/dashboard/widget';
import { Filter } from 'components/molecules/filters/types';
import { FieldGroup } from 'components/molecules/views';
import { ColumnOrder } from 'components/organisms/grid-custom-column';

export interface ApiProjectListViewDefinition {
  filter?: SimpleSearchFilter;
  group?: { fields: FieldGroup[] };
  columnOrder?: ColumnOrder[];
}
export interface ProjectListViewDefinition {
  filter: Filter;
  groupBy: string;
  columnOrder?: ColumnOrder[];
}

export enum ProjectViews {
  MyProjects = -1,
  AllProjects = -2,
}
